import Card from './Card';
import CardTitle from './CardTitle';
import CardDescription from './CardDescription';
import TacticCounter from './TacticCounter';
import ActionButton from './ActionButton';

export type { CardType } from './Card';
export type { CardTitleProps } from './CardTitle';
export type { CardDescriptionProps } from './CardDescription';
export type { TacticCounterProps } from './TacticCounter';
export type { ActionButtonProps } from './ActionButton';

export default Card;
export { CardTitle, CardDescription, TacticCounter, ActionButton };
